"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

require("core-js/modules/web.dom.iterable");

var _classCallCheck2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/createClass.js"));

var _asyncValidator = _interopRequireDefault(require("async-validator"));

var validator = /*#__PURE__*/function () {
  /**
   * 构造
   * @param rules object async-validator rules
   * @param data  初始对象
   */
  function validator(rules, data) {
    (0, _classCallCheck2.default)(this, validator);
    this.setData(data);
    this.setRules(rules);
  }
  /**
   * 重新定义初始对象
   * 也可以直接修改实例的data
   * validator.data = newData
   * @param data
   */


  (0, _createClass2.default)(validator, [{
    key: "setData",
    value: function setData(data) {
      this.data = data;
    }
    /**
     * 设定规则
     * @param rules rules object async-validator rules
     * @param cover 是否替换旧规则
     */

  }, {
    key: "setRules",
    value: function setRules(rules) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          cover = _ref.cover;

      if (cover === undefined || cover) {
        this.validators = {};
      }

      for (var attr in rules) {
        var rule = {};
        rule[attr] = rules[attr];
        this.validators[attr] = new _asyncValidator.default(rule);
      }
    }
    /**
     * 执行验证
     * @param callback(errors, fields)
     * @param data 可选 传空将验证构造data 传string或数组验证构造data的响应字段
     * 以上参数顺序可互转
     */

  }, {
    key: "validate",
    value: function validate(callback, data) {
      var _this = this;

      var cb, d;

      if (typeof callback === 'function') {
        cb = callback;
        d = data;
      } else if (typeof data === 'function') {
        cb = data;
        d = callback;
      }

      var _d = d;

      if (this.data) {
        if (!d) {
          _d = this.data;
        } else if (typeof d === 'string') {
          _d = {};
          _d[d] = this.data[d];
        } else if (Array.isArray(d)) {
          _d = {};
          d.forEach(function (attr) {
            _d[attr] = _this.data[attr];
          });
        }
      }

      var err = [];

      if (_d) {
        for (var attr in _d) {
          if (this.validators[attr]) {
            var o = {};
            o[attr] = _d[attr];
            this.validators[attr].validate(o, function (error) {
              if (error) {
                err.push(error[0]);
              }
            });
          }
        }
      }

      cb && cb(err.length > 0, err);
    }
  }]);
  return validator;
}();

function _default(rules, data) {
  return new validator(rules, data);
}